import '../css/Navbar_comunity.css'

function ComunityNavbar(){

    return <div className='comNavbar-container'>
        <ul className='comNav-lists'>
            <li className='content'><a href=''>Tekonologi</a></li>
            <li className='content'><a href=''>Sosial</a></li>
            <li className='content'><a href=''>Kesehatan</a></li>
            <li className='content'><a href=''>Pendidikan</a></li>
            <li className='content'><a href=''>Seni</a></li>
        </ul>
        


    </div>

}

export default ComunityNavbar